import axios from 'axios'
import qs from 'qs'

export default {
  init () {
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.interceptors.request.use(config => {
      if (config.method === 'post') {
        config.data = qs.stringify(config.data)
      } else if (config.method === 'get') {
        config.params = {
          ...config.params
        }
      }
      return config
    }, error => {
      return Promise.reject(error)
    })

    // http response 拦截器
    axios.interceptors.response.use(response => {
      switch (response.data.code) {
        case 9999:
          break
        default:
          alert(response.data.msg.context)
      }
      return response
    }, error => {
      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/config-axios.js